<div> 
  <app-rmpv-oficina-filtro
        [filtros]="filtros">
  </app-rmpv-oficina-filtro>
  <app-rmpv-oficina-lista
        [filtros]="filtros"
        (definirFiltro)="definirFiltro()"
        (exibir)="selecionar($event)">
  </app-rmpv-oficina-lista>
 </div>
 
